/*
 * @Desc: 题目配置 接口
 * @Author: may.li
 * @Date: 2023-05-21 10:24:59
 * @LastEditors: 赵佳明
 * @LastEditTime: 2024-04-19 11:51:54
 */
import request from "@/utils/request";
const index = {
    // 列表
    list(query) {
        return request({
            url: "/wenjuanti/list",
            method: "get",
            params: query
        });
    },
    // 新增
    create(data) {
        return request({
            url: "/wenjuanti/create",
            method: "post",
            data
        });
    },
    // 编辑
    edit(data) {
        return request({
            url: "/wenjuanti/edit",
            method: "post",
            data
        });
    },
    // 题目详情 
    detail(data) {
        return request({
            url: "/wenjuanti/detail",
            method: "post",
            data
        });
    },
    // 上移下移
    sort(data) {
        return request({
            url: "/wenjuanti/sort",
            method: "post",
            data
        });
    },
    // 删除题目
    remove(data) {
        return request({
            url: "/wenjuanti/remove",
            method: "post",
            data
        });
    },
    // 选项列表
    getOption(query) {
        return request({
            url: "/wenjuanti/getOption",
            method: "get",
            params: query
        });
    },
    // 添加选项
    addOption(data) {
        return request({
            url: "/wenjuanti/addOption",
            method: "post",
            data
        });
    },
    // 修改选项
    editOption(data) {
        return request({
            url: "/wenjuanti/editOption",
            method: "post",
            data
        });
    },
    // 选项上移下移
    sortOption(data) {
        return request({
            url: "/wenjuanti/sortOption",
            method: "post",
            data
        });
    },
    // 删除选项
    removeOption(data) {
        return request({
            url: "/wenjuanti/removeOption",
            method: "post",
            data
        });
    },
    // 跳题配置详情
    skipDetail(query) {
        return request({
            url: "/wenjuanti/skipDetail",
            method: "get",
            params: query
        });
    },
    // 题下拉选
    tiSelect(query) {
        return request({
            url: "/wenjuanti/tiSelect",
            method: "get",
            params: query
        });
    },
    // 配置跳题
    setSkip(data) {
        return request({
            url: "/wenjuanti/setSkip",
            method: "post",
            data
        });
    },
};
export default index;
